export function initCard (options) {
  var defaults = {
    masks: {
      cardNumber: '•' // optional - mask card number
    },
  };

  const opts = Object.assign({}, defaults, options);

  return new window.Card(opts);
}
